export default {"src":"/_next/static/media/Logo_Symbol_Dark.a5805282.svg","height":56,"width":56};